import { get } from '../fetch';
import { useEffect, useState } from 'react';

/**
 * Hook personnalisé pour récupérer la liste des domaines
 * 
 * Ce hook :
 * - Récupère la liste des domaines depuis l'API
 * - Met à jour automatiquement l'état local
 * - Retourne la liste des domaines disponibles
 * 
 * Logique métier :
 * - Appel API unique au montage du composant
 * - Gestion automatique de l'état de chargement
 * - Retour des entités avec nom et ID
 * 
 * @returns Liste des domaines disponibles
 */
export function useDomains() {
  const [domains, setDomains] = useState<CRM.EntityName[]>([]);

  useEffect(() => {
    get<CRM.EntityName[]>('domains').then(setDomains);
  }, []);

  return domains;
}
